<div style="text-align:center">
  <h2>
    Feel free to {{title}}!
  </h2>
</div>
<nav>
  <a routerLink="/slots">Availble slots</a>
</nav>
<router-outlet></router-outlet>
<app-messages></app-messages>